import type { IconProps } from '@/components/CustomIcon/types';

export const LeftArrowIcon = ({
  size = 18,
  className,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.6375 9C15.6356 9.14858 15.5757 9.29052 15.4706 9.39559C15.3655 9.50067 15.2236 9.56055 15.075 9.5625H8.955V12C8.96085 12.0894 8.93848 12.1784 8.89103 12.2543C8.84359 12.3303 8.77347 12.3895 8.69059 12.4235C8.6077 12.4575 8.51624 12.4645 8.42911 12.4437C8.34198 12.4229 8.26359 12.3753 8.205 12.3075L5.205 9.3075C5.12622 9.22752 5.08206 9.11976 5.08206 9.0075C5.08206 8.89523 5.12622 8.78747 5.205 8.70749L8.205 5.7075C8.26281 5.64098 8.33977 5.59395 8.42534 5.57285C8.5109 5.55176 8.6009 5.55762 8.683 5.58964C8.76511 5.62166 8.83531 5.67828 8.884 5.75173C8.93269 5.82519 8.95749 5.9119 8.955 5.99999V8.42249H15.075C15.1499 8.42347 15.2238 8.43919 15.2926 8.46874C15.3614 8.49829 15.4236 8.54111 15.4759 8.59473C15.5281 8.64836 15.5693 8.71175 15.597 8.78129C15.6247 8.85082 15.6385 8.92514 15.6375 9ZM2.925 3.63C2.77582 3.63 2.63274 3.68926 2.52726 3.79475C2.42177 3.90024 2.3625 4.04331 2.3625 4.1925V13.8075C2.3625 13.9567 2.42177 14.0998 2.52726 14.2052C2.63274 14.3107 2.77582 14.37 2.925 14.37C3.07419 14.37 3.21726 14.3107 3.32275 14.2052C3.42824 14.0998 3.4875 13.9567 3.4875 13.8075V4.1925C3.48851 4.11835 3.47465 4.04475 3.44674 3.97605C3.41883 3.90735 3.37743 3.84493 3.325 3.7925C3.27256 3.74006 3.21015 3.69867 3.14145 3.67076C3.07275 3.64285 2.99915 3.62899 2.925 3.63Z"
        fill="currentColor"
      />
    </svg>
  );
};
